import { render, staticRenderFns } from "./OptionsLogin.vue?vue&type=template&id=4b210054&class=true&"
import script from "./OptionsLogin.vue?vue&type=script&lang=ts&"
export * from "./OptionsLogin.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports